import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./hooks/useAuth";
import App from "./App.tsx";
import "./index.css";

// Auto-reload when a lazy-loaded chunk is missing (stale deploy cache)
const isChunkLoadError = (msg?: string) =>
  !!msg && /Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(msg);
const tryReload = () => {
  const key = "__chunk_reload_ts";
  const last = Number(sessionStorage.getItem(key) || 0);
  if (Date.now() - last > 10000) {
    sessionStorage.setItem(key, String(Date.now()));
    window.location.reload();
  }
};
window.addEventListener("error", (e) => {
  if (isChunkLoadError(e.message)) tryReload();
});
window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
  const reason: any = e.reason;
  if (isChunkLoadError(reason?.message || String(reason))) tryReload();
});


createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
